import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useMobileSearchStore = defineStore('search', () => {
  const isActive = ref(false)

  const showSearch = () => {
    isActive.value = true
  }

  const close = () => {
    isActive.value = false
  }

  return {
    isActive,
    showSearch,
    close,
  }
})
